export default __webpack_public_path__ + "static/media/slide13.cec2ffdd.jpg";